/**
 * Deep-merge plain objects. Arrays are replaced when `source` provides an array.
 * Used for locale patches over CMS page JSON.
 */
export function deepMerge(target, source) {
    const out = { ...target };
    for (const key of Object.keys(source)) {
        const sv = source[key];
        const tv = out[key];
        if (Array.isArray(sv)) {
            out[key] = sv;
            continue;
        }
        if (sv !== null && typeof sv === 'object' && !Array.isArray(sv)) {
            out[key] =
                tv !== null && typeof tv === 'object' && !Array.isArray(tv)
                    ? deepMerge(tv, sv)
                    : { ...sv };
            continue;
        }
        out[key] = sv;
    }
    return out;
}
